import { Behavior } from "./behavior";

export declare class HighlightBehavior extends Behavior {
    
}
